@if (submitLabel()) {
  <form class="modal" novalidate (submit)="submit($event)">
    <ng-container [ngTemplateOutlet]="frame" />
  </form>
} @else {
  <div class="modal">
    <ng-container [ngTemplateOutlet]="frame" />
  </div>
}

<ng-template #frame>
  <header class="modal__head">
    <h2 mat-dialog-title class="modal__title">{{ heading() }}</h2>
    @if (description(); as text) {
      <p class="modal__description">{{ text }}</p>
    }
  </header>

  <mat-dialog-content class="modal__body">
    <ng-content />
    @if (error(); as message) {
      <div class="error-banner modal__error" role="alert" data-testid="modal-error">
        {{ message }}
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="modal__foot" align="end">
    <ng-content select="[modalFooterStart]" />
    @if (submitLabel(); as label) {
      <button mat-stroked-button type="button" (click)="dismiss()" data-testid="modal-cancel">
        Cancel
      </button>
      <button mat-flat-button type="submit" [disabled]="pending()" data-testid="modal-submit">
        @if (pending()) {
          <mat-spinner diameter="20" />
        } @else {
          {{ label }}
        }
      </button>
    } @else {
      <button mat-flat-button type="button" (click)="dismiss()" data-testid="modal-done">
        Close
      </button>
    }
  </mat-dialog-actions>

  <button
    type="button"
    class="modal__close"
    aria-label="Close"
    matTooltip="Close"
    (click)="dismiss()"
    data-testid="modal-close"
  >
    <app-icon name="x" [size]="16" />
  </button>
</ng-template>
